import breakpoints from '@assets/theme/breakpoints';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const DealPageStyledContainer = styled(Box)`
  display: grid;
  position: relative;
  margin-bottom: 40px;
  grid-template-columns: 1fr;
  color: ${({ theme }) => theme.palette.grey[700]};
  letter-spacing: normal;
  padding: 0;
  width: 100%;

  @media (max-width: ${breakpoints.values.lg}px) {
    grid-gap: 20px;
    padding: 0 20px 90px 20px;
  }

  .header {
    margin-bottom: 45px;
  }

  .title {
    margin: 7px 0 0 0;
    color: ${({ theme }) => theme.palette.common.black};
    font-size: 40px;
    font-weight: 400;
    line-height: normal;

    @media (max-width: ${breakpoints.values.md}px) {
      margin: 6px 0 30px;
      font-size: 25px;
    }
  }

  .deal-status-wrapper {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .deal-status {
    margin-top: 20px;
    display: inline-block;
    padding: 7px 84px;
    font-size: 16px;
    font-weight: 400;
    color: #3460b4;
    border-radius: 8px;
    background-color: #eff3fb;

    &.error {
      background-color: ${({ theme }) => theme.palette.error.light};
      color: #000000;
    }
  }
`;
